var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-tab-item', {
    attrs: {
      "value": _vm.Liquid.value
    }
  }, [_c('v-container', [_c('top-image', {
    attrs: {
      "tit": _vm.Liquid.text,
      "bgImage": "/images/sub/product/liquid-bg.jpg",
      "image": "/images/sub/product/liquid-img.png"
    }
  }, [_c('p', {
    staticClass: "page-text mb-6 mb-lg-20"
  }, [_vm._v(" 케이아이이 시스템즈는 수소 이온 농도 지수(pH), 산화환원전위(ORP), 전도도(Conductivity), 총유기탄소(TOC), 염소(Chlorine), 암모니아(Ammonia), 용존 산소(Dissolved Oxygen)와 같은 주요 매개 변수의 정확하고 신뢰성 높은 측정을 제공하도록 설계된 액체 분석 시스템 (Liquid Analyzer System)을 제공합니다. ")]), _c('p', {
    staticClass: "page-text mb-6 mb-lg-20"
  }, [_vm._v(" 액체분석 시스템은 중요한 자본 자산인 보일러 및 냉각탑 등을 보호하기 위해 필수적이며, 케이아이이 시스템즈의 시스템은 공정 액체의 화학성분을 모니터링하고 조정하여 최적의 성능을 유지할 수 있도록 지원합니다. 이를 통해 부식 방지, 유지보수 최소화, 가동시간 극대화 등의 이점을 얻을 수 있습니다. ")]), _c('p', {
    staticClass: "page-text"
  }, [_vm._v(" 액체분석 시스템은 매우 유연하게 구성할 수 있으며, 고객의 특정 요구 사항에 맞게 맞춤형으로 제작할 수 있습니다. 시스템은 발전소, 수처리 및 화학 처리와 같은 광범위한 산업분야에서 사용할 수 있습니다. ")])])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }